import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function ManualEntryIcon({ className, fill = '#324A52' }: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="13"
      viewBoxDimensions="0 0 16 16"
      width="13"
    >
      <path
        clipRule="evenodd"
        d="M8 0.933105C5.8645 0.933105 4.13333 2.66427 4.13333 4.79977C4.13333 6.56284 5.31332 8.05031 6.92664 8.51552C5.65301 8.67072 4.56061 9.1212 3.73767 9.93222C2.6903 10.9645 2.16002 12.5011 2.16002 14.5063C2.16002 14.7862 2.38687 15.013 2.66669 15.013C2.94651 15.013 3.17335 14.7862 3.17335 14.5063C3.17335 12.6717 3.65638 11.4351 4.44897 10.654C5.24305 9.87138 6.42852 9.46643 7.99994 9.46643C9.57138 9.46643 10.7569 9.87138 11.551 10.654C12.3436 11.4351 12.8267 12.6717 12.8267 14.5063C12.8267 14.7862 13.0534 15.013 13.3333 15.013C13.6131 15.0131 13.84 14.7862 13.84 14.5064C13.84 12.5011 13.3097 10.9645 12.2623 9.93221C11.4394 9.12121 10.3469 8.67074 9.07333 8.51553C10.6866 8.05033 11.8667 6.56285 11.8667 4.79977C11.8667 2.66427 10.1355 0.933105 8 0.933105ZM5.14666 4.79977C5.14666 3.22392 6.42415 1.94644 8 1.94644C9.57585 1.94644 10.8533 3.22392 10.8533 4.79977C10.8533 6.37562 9.57585 7.65311 8 7.65311C6.42415 7.65311 5.14666 6.37562 5.14666 4.79977Z"
        fill={fill}
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
